import script from "./rolesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./rolesList.vue?vue&type=script&lang=ts&setup=true"

import "./rolesList.vue?vue&type=style&index=0&id=e49026b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e49026b2"]])

export default __exports__